import React, { SVGProps } from "react";

export default function SupInsights(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.8613 5.25627L12.3529 3.88232L11.8445 5.25627L10.4706 5.76468L11.8445 6.27308L12.3529 7.64703L12.8613 6.27308L14.2353 5.76468L12.8613 5.25627Z"
        fill="currentColor"
      />
      <path
        d="M18 5.76468C18 6.28447 17.5786 6.70585 17.0588 6.70585C17.0042 6.70585 16.9506 6.70119 16.8985 6.69225L13.2365 11.0867C13.2738 11.188 13.2941 11.2975 13.2941 11.4117C13.2941 11.9315 12.8727 12.3529 12.3529 12.3529C11.8787 12.3529 11.4864 12.0021 11.4213 11.5459L8.22913 10.269C8.06897 10.3952 7.86681 10.4706 7.64706 10.4706C7.59239 10.4706 7.53881 10.4659 7.4867 10.457L3.82469 14.8513C3.86199 14.9526 3.88235 15.0622 3.88235 15.1764C3.88235 15.6962 3.46097 16.1176 2.94118 16.1176C2.42138 16.1176 2 15.6962 2 15.1764C2 14.6566 2.42138 14.2353 2.94118 14.2353C2.99586 14.2353 3.04945 14.2399 3.10158 14.2489L6.76356 9.85455C6.72625 9.75321 6.70588 9.64367 6.70588 9.52938C6.70588 9.00959 7.12726 8.58821 7.64706 8.58821C8.1213 8.58821 8.51362 8.93896 8.57874 9.3952L11.7709 10.6721C11.9311 10.5459 12.1332 10.4706 12.3529 10.4706C12.4076 10.4706 12.4613 10.4752 12.5134 10.4842L16.1753 6.08987C16.138 5.98852 16.1176 5.87898 16.1176 5.76468C16.1176 5.24488 16.539 4.8235 17.0588 4.8235C17.5786 4.8235 18 5.24488 18 5.76468Z"
        fill="currentColor"
      />
      <path
        d="M4.35294 6.70585L4.86135 8.0798L6.23529 8.58821L4.86135 9.09661L4.35294 10.4706L3.84453 9.09661L2.47059 8.58821L3.84453 8.0798L4.35294 6.70585Z"
        fill="currentColor"
      />
    </svg>
  );
}
